"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _CampaignDetails = _interopRequireDefault(require("../CampaignDetails/CampaignDetails"));

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    root: {
      borderTop: "1px solid  ".concat(palette.dividerLight),
      padding: spacing(2)
    },
    icon: {
      color: 'inherit',
      fontSize: 'inherit',
      marginRight: spacing(1)
    },
    avatar: {
      width: 46,
      height: 46,
      border: "4px solid ".concat(palette.common.white),
      boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      marginRight: spacing(2),
      textTransform: 'uppercase',
      backgroundColor: function backgroundColor(_ref2) {
        var _backgroundColor = _ref2.backgroundColor;
        return _backgroundColor;
      }
    },
    subTitle: {
      marginTop: spacing(2)
    },
    plusAvatar: {
      width: spacing(2),
      height: spacing(2),
      backgroundColor: palette.divider
    }
  };
});

var CampaignListItem = function CampaignListItem(_ref3) {
  var campaign = _ref3.campaign,
      disabled = _ref3.disabled,
      showInvitations = _ref3.showInvitations,
      apiHost = _ref3.apiHost,
      onSelectCampaign = _ref3.onSelectCampaign;
  var name = campaign.name,
      avatarColor = campaign.avatarColor,
      giftsLimit = campaign.giftsLimit,
      team = campaign.team;
  var classes = useStyles({
    backgroundColor: avatarColor
  });

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      showSettings = _useState2[0],
      setShowSettings = _useState2[1];

  var avatarLetters = (0, _react.useMemo)(function () {
    return name.split(' ').map(function (item) {
      return item[0];
    }).join('').substring(0, 2);
  }, [name]);
  var trySelectCampaign = (0, _react.useCallback)(function () {
    if (!disabled) {
      onSelectCampaign(campaign);
    }
  }, [disabled, onSelectCampaign, campaign]);
  return /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column",
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    wrap: "nowrap"
  }, /*#__PURE__*/_react.default.createElement(_material.Avatar, {
    className: classes.avatar
  }, avatarLetters), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: disabled ? 'Body-Medium-Link-Disabled' : 'Body-Medium-Link Text-Pointer',
    "data-disable": disabled,
    onClick: trySelectCampaign
  }, name), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: "Body-Small-Static"
  }, "via ", team.name, " Team"), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    direction: "row",
    justifyContent: "space-between",
    alignItems: "baseline",
    wrap: "nowrap"
  }, showInvitations && /*#__PURE__*/_react.default.createElement(_material.Typography, {
    className: (0, _classnames.default)(disabled ? 'Subcopy-Italic-Error' : 'Subcopy-Italic-Success', classes.subTitle),
    "data-testid": "".concat(name, "_gift_invites_amount")
  }, /*#__PURE__*/_react.default.createElement(_ui.Icon, {
    icon: disabled ? 'ban' : 'gift',
    className: classes.icon
  }), "You have ", giftsLimit.remainingAmount, " invitation remaining"), /*#__PURE__*/_react.default.createElement(_ui.LinkButton, {
    className: "Subcopy-Regular-Link",
    onClick: function onClick() {
      return setShowSettings(!showSettings);
    }
  }, showSettings ? 'Hide' : 'View', " default settings")))), /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: showSettings
  }, /*#__PURE__*/_react.default.createElement(_CampaignDetails.default, {
    apiHost: apiHost,
    campaign: campaign
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(CampaignListItem);

exports.default = _default;